import request from '@/utils/request.js'


export function noticePageList(parameter) {
  return request({
    url: '/student/notice/pageList',
    method: 'post',
    params: parameter
  })
}
export function noticeDetail(parameter) {
  return request({
    url: '/student/notice/detail',
    method: 'post',
    params: parameter
  })
}

export function count(parameter) {
  return request({
    url: '/student/notice/count',
    method: 'post',
    params: parameter
  })
}
